import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getFileEntities: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/entities`,
        cache: true,
        isArray: true
    },
    query: {
        method: 'GET',
        url: `${BASE_PATH_API}/:entityTypeRoute/:entityId/files`,
        isArray: true
    },
    deleteFile: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/:entityTypeRoute/:entityId/files/:entityTypeId/:fileId`
    },
    saveFiles: {
        method: 'POST',
        url: `${BASE_PATH_API}/v2/files`
    },
    getFileShareTypes: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/sharedTypes/:entityTypeId`
    },
    getCategories: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/categoryOptions`,
        isArray: true
    },
    getPresignedUrl: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/getPresignedUrl`,
    },
    getRentalApplicationAttachmentPresignedUrl: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/attachment/getPresignedUrl`,
    },
    getFileById: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/:id`,
    },
    getFiles: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/grid`,
        params: {
            '$count': true
        }
    },
    deleteFileById: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/files/:fileId`
    },
    getSharedFiles: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/sharedFiles`,
        params: {
            '$count': true
        }
    },
    getFileByIdWithSharedDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/grid/:fileId`,
    },
    getFilesByEntityId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/files`
    },
    queryRentalOwners: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/listForFiles`,
        isArray: true
    },
    updateFileCategoriesInBulk: {
        method: 'PUT',
        url: `${BASE_PATH_API}/v3/files/categories/bulk`
    },
    getDetailedFileInfoById: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/detailed/:id`,
    },
    getBuildingByFileId: {
        method: 'GET',
        url: `${BASE_PATH_API}/files/:fileId/building`,
    },
    notifyUsers: {
        method: 'Post',
        url: `${BASE_PATH_API}/files/notifyUsers`,
    },
    getSecureFileSource: {
        method: 'GET',
        url: ':sourceUrl',
        responseType: 'blob',
        transformResponse: function transformResponse(response, headers) {
            const contentDisposition = headers.get('content-disposition')
                ? headers.get('content-disposition').split('filename=')
                : [];

            return {
                data: response,
                filename: contentDisposition && contentDisposition.length > 1
                    ? contentDisposition[contentDisposition.length - 1]
                    : null
            };
        }
    },
};

export function FilesApi() {
    return createActions(actions);
}
